<template>
    <b-card no-body class="shadowed h-100 p-4 mx-2">
        <div class="d-flex flex-column justify-content-start mx-0 h-100">
            <div class="clearfix">
                <b-img :src="illustration" right class="w-50" />
            </div>
            <h6 class="mt-3">{{ title }}</h6>
            <p>{{ description }}</p>
            <ul class="list-unstyled mt-auto">
                <li v-if="modulesNumber > 0">
                    <small>
                        <b-icon icon="list"></b-icon>
                        <span class="font-weight-bold">
                            {{ modulesNumber }} {{ transChoice("home.module", modulesNumber) }}
                        </span>
                    </small>
                </li>
                <li v-if="missionsNumber > 0">
                    <small>
                        <b-icon icon="star"></b-icon>
                        <span class="font-weight-bold">
                            {{ missionsNumber }} {{ transChoice("home.mission", missionsNumber) }}
                        </span>
                    </small>
                </li>
            </ul>
            <div class="d-flex justify-content-end">
                <b-button
                    variant="secondary"
                    size="sm"
                    class="font-weight-bold"
                    @click="$emit('ctaClicked')"
                    :disabled="buttonDisabled"
                >
                    {{ buttonText }}
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
    export default {
        props: {
            title: String,
            description: String,
            illustration: String,
            modulesNumber: Number,
            missionsNumber: Number,
            buttonText: String,
            buttonDisabled: Boolean,
        }
    }
</script>
